import Intercom from 'images/intercom.svg';
import IntercomTrigger from 'images/intercom-trigger.svg';
import React from 'react';
import { useIntercomShow } from 'components/intercom/hooks/use-intercom-show';
import classNames from 'classnames';

var IntercomTriggerIcon = function IntercomTriggerIcon(_ref) {
  var additionalClassName = _ref.additionalClassName;
  var intercomShow = useIntercomShow();

  var handlerIntercomToggle = function handlerIntercomToggle() {
    intercomShow();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames('cursor-pointer', additionalClassName),
    onClick: handlerIntercomToggle,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: Intercom,
    className: "w-30"
  })), /*#__PURE__*/React.createElement("img", {
    src: IntercomTrigger,
    className: "ml-12p mt-4p"
  }));
};

export { IntercomTriggerIcon };